import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "af0fb1d3-6a62-459a-90c1-2fa5e19a2455", content: "V∙m∙s", options: {} },
  { id: "10814fc9-3663-4e0a-8302-fa747646043e", content: "V/m/s", options: {} },
  { id: "4cf06592-98fd-495c-846c-9398087005c2", content: "V∙s/m", options: {} },
  { id: "ee84d27e-f00c-480f-bb01-ab81b41d8376", content: "m/s/V", options: {} },
  { id: "02f55e8c-1262-4adb-af90-de1e422a752e", content: "m∙s/V", options: {} },
  { id: "e09dc81a-bff2-401c-a22e-eef221807c65", content: "V∙m/s", options: {} },
];

export const task: Task = {
  id: "9de9adba-f092-402b-aec9-6f9a6a487892",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4cf06592-98fd-495c-846c-9398087005c2"],
};
